export default __webpack_public_path__ + "efc22c27a3778e34ab06a090bbe54612.svg";